import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_INVENTORY_QUERY_KEY } from '~/features/hooks/useGetInventory'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { InventoryV2 } from '~/supabase/types'

export const usePatchInventory = () => {
  const { mutate: notifyError } = useNotifyError()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['patch-inventory'],
    mutationFn: async (payload: Array<Partial<Omit<InventoryV2, 'id'>> & { id: number }>) => {
      const promises = await Promise.all(
        payload.map((p) => supabaseApi.from('inventory_v2').update(p).eq('id', p.id))
      )
      const errors = promises.map((p) => p.error)

      errors.forEach((error) => {
        if (error) {
          toast.error('Inventory update failed')
          notifyError({
            message: 'Inventory update failed.',
            data: { payload },
            error,
            function: 'usePatchInventory',
          })

          throw error
        } else {
          toast.success('Inventory updates successful.')
          queryClient.invalidateQueries({ queryKey: [GET_INVENTORY_QUERY_KEY] })
        }
      })
    },
  })
}
